export default {"src":"/_next/static/media/infinite-layers.9f5c340a.svg","height":150,"width":300,"blurWidth":0,"blurHeight":0};